/**
 * @module NackleIllustration
 * @description A collection of illustration components for various empty and error states.
 */
const NackleIllustration = {};
import AllCaughtUp from './all-caught-up.js';
import ArcadeWinner from './arcade-winner.js';
import CelebrationEmpty from './celebration-empty.js';
import CustomerService from './customer-service.js';
import DownForMaintenance from './down-for-maintenance.js';
import FailedLoad from './failed-load.js';
import InboxEmpty from './inbox-empty.js';
import NoRecognitions from './no-recognitions.js';
import NoReportsSelected from './no-reports-selected.js';
import NoResultsFound from './no-results-found.js';
import PageMoved from './page-moved.js';
import PageNotFound from './page-not-found.js';
import PermanentlyDown from './permanently-down.js';
import ScheduledMaintenance from './scheduled-maintenance.js';
import ToDosDone from './todos-done.js';
import UnderConstruction from './under-construction.js';

NackleIllustration.AllCaughtUp = AllCaughtUp;
NackleIllustration.ArcadeWinner = ArcadeWinner;
NackleIllustration.CelebrationEmpty = CelebrationEmpty;
NackleIllustration.CustomerService = CustomerService;
NackleIllustration.DownForMaintenance = DownForMaintenance;
NackleIllustration.FailedLoad = FailedLoad;
NackleIllustration.InboxEmpty = InboxEmpty;
NackleIllustration.NoRecognitions = NoRecognitions;
NackleIllustration.NoReportsSelected = NoReportsSelected;
NackleIllustration.NoResultsFound = NoResultsFound;
NackleIllustration.PageMoved = PageMoved;
NackleIllustration.PageNotFound = PageNotFound;
NackleIllustration.PermanentlyDown = PermanentlyDown;
NackleIllustration.ScheduledMaintenance = ScheduledMaintenance;
NackleIllustration.ToDosDone = ToDosDone;
NackleIllustration.UnderConstruction = UnderConstruction;

export { NackleIllustration };